import { enumCameraStatus } from '@rematter/frontend-lib-api-client';

import { CameraDetailRecord } from '../types/sidecar';

import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';
import { parseZonedDateTime } from '~/shared/utils/dateTime';

export const cameraDetailQueryAtom = createQueryAtomFactory(
  'settings.cameraDetail',
  (params: { ids: string[] }) => ({
    cameras: {
      __args: {
        filter: {
          ids: params.ids,
        },
        pagination: {
          limit: 1,
          offset: 0,
        },
      },
      entries: {
        id: true,
        sidecarId: true,
        uniqueId: true,
        driverType: true,
        name: true,
        ipAddress: true,
        manufacturer: true,
        model: true,
        firmwareVersion: true,
        status: true,
        online: true,
        initialized: true,
        streamProfile: true,
        streamUrl: true,
        snapshotUrl: true,
        lastSeenAt: true,
        hasPtz: true,
        hasFloodlight: true,
        hasSiren: true,
        username: true,
        passwordDecrypted: true,
        sidecar: {
          id: true,
          name: true,
          peerId: true,
          multiaddrs: true,
          status: true,
        },
        timestamps: {
          createdAt: true,
          updatedAt: true,
        },
      },
    },
  }),
  {
    select: (data): CameraDetailRecord | null => {
      const entry = data?.cameras?.entries?.[0];
      if (!entry) {
        return null;
      }

      return {
        id: entry.id,
        sidecarId: entry.sidecarId,
        uniqueId: entry.uniqueId,
        driverType: entry.driverType,
        name: entry.name,
        ipAddress: entry.ipAddress ?? null,
        manufacturer: entry.manufacturer ?? null,
        model: entry.model ?? null,
        firmwareVersion: entry.firmwareVersion ?? null,
        status: entry.status ?? enumCameraStatus.Discovered,
        online: entry.online ?? false,
        initialized: entry.initialized ?? false,
        streamProfile: entry.streamProfile ?? 'sub',
        streamUrl: entry.streamUrl ?? null,
        snapshotUrl: entry.snapshotUrl ?? null,
        lastSeenAt: entry.lastSeenAt
          ? parseZonedDateTime(entry.lastSeenAt)
          : null,
        hasPtz: entry.hasPtz ?? false,
        hasFloodlight: entry.hasFloodlight ?? false,
        hasSiren: entry.hasSiren ?? false,
        username: entry.username ?? null,
        passwordDecrypted: entry.passwordDecrypted ?? null,
        sidecar: entry.sidecar
          ? {
              id: entry.sidecar.id,
              name: entry.sidecar.name,
            }
          : null,
        sidecarDetail: entry.sidecar
          ? {
              id: entry.sidecar.id,
              name: entry.sidecar.name,
              peerId: entry.sidecar.peerId ?? null,
              multiaddrs: (entry.sidecar.multiaddrs as string[]) ?? [],
              status: entry.sidecar.status,
            }
          : null,
        timestamps: {
          createdAt: parseZonedDateTime(entry.timestamps.createdAt),
          updatedAt: parseZonedDateTime(entry.timestamps.updatedAt),
        },
      };
    },
  },
);
